import { withTheme } from '@front10/container-elements';
import withCommonEMContainer from '../_commons/CommonEMContainer';
import EventFinderCarousel from './EventFinderCarousel';

export default withCommonEMContainer(withTheme(EventFinderCarousel));
